import { useState as o } from "react";
const a = () => {
  const [s, e] = o(!1);
  return {
    isHovered: s,
    handleMouseEnter: () => e(!0),
    handleMouseLeave: () => e(!1)
  };
};
export {
  a as useMenuHover
};
